import React, { useContext, useEffect, useState } from "react";
import { Backdrop } from "@mui/material";
import moment from "moment";
import { ReactComponent as BackIcon } from "assets/img/svg/BackButton.svg";
import { ReactComponent as EditIcon } from "assets/img/svg/GreyEditIcon.svg";

import ALoader from "views/pages/manage/common/a-loader";
import ADataGrid from "views/pages/manage/common/data-grid/EnhanceDataGrid";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import { AGridColDef } from "views/pages/manage/common/data-grid/ADataGridColDef";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import CustomDatePicker from "views/pages/manage/common/commonComponents/CustomDatePicker";
import IconButtonWrapper from "views/pages/manage/common/form-fields-mui/IconButtonWrapper.jsx";
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";
import { regex } from "views/pages/manage/common/constant";

import {
  fetchAllPostPromisedData,
  fetchAllPromisedData,
  getFormattedTime,
} from "../../../../common/utils/methods/commonMethods/utilityMethod";
import { endpoint, pages } from "../../../../common/constant";
import styles from "./logsTableStyle.module.css";
import { RolePermissions } from "appContext";
import { PermissionContext } from "appContext";
import { MODULE_MASTER_LABEL_VALUE_MAP, MODULE_MASTER_TYPE, statusDropdown } from "./constant";
import { failureToast, successToast } from "../../../../common/utils/methods/toasterFunctions/function";
import APopover from "../../../../common/a-popover";
import {ReactComponent as QuestionMarkIcon} from "assets/img/svg/QuestionMarkConfirmationDialog.svg";
import {ReactComponent as CrossIcon} from "assets/img/svg/CrossIcon.svg";
import { useGetPermissions } from "../../../../../../../layouts/customHook";

const AInputStyle = { height: "40px" };

export const findModule = (moduleName, moduleList = []) => {

  return moduleList.find((item) => item.disabledModules === moduleName);
};

const RunCRON = ({
  label,
  value,
  details,
  cronStatusDetails,
  fetchCronStatus,
  setIsLoading
}) => {

  const { daysBeforeStart, status } = details ?? {};
  const cronAccountingDate = moment(new Date).subtract(daysBeforeStart, "days").format('DD MMM YYYY');
  const accountingType = value?.split("_")?.[0];
  const cronStatus = cronStatusDetails?.find(el => el?.jobName?.includes(accountingType));
  const {startTime, createdBy} = cronStatus ?? {};

  const runCron = async (closePopup) => {
    try {
      setIsLoading(true);
      const resp = await fetchAllPostPromisedData(`${endpoint.accountingCron.triggerCron}/?type=${accountingType}`, {});
      if (resp?.code === 200) {
        successToast(resp?.data);
        await fetchCronStatus();
        closePopup();
      }

    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);

    }
  }

  return (
    <div className="d-inline-block ml-auto">
    <APopover  
      buttonComponent={openPopup =>
        <AButton
          variant="primary_filled"
          size="xs"
          onClick={openPopup}
          disabled={status !== 'ACTIVE'}
          className="mt-1 ml-auto"
        >
          Run CRON
        </AButton>


      }

      menuComponent={closePopup => (
        <div style={{ width: '450px' }} className="p-3">

          <div className="d-flex justify-content-between">
            <QuestionMarkIcon />
            <CrossIcon onClick={closePopup}/>
          </div>

          <h3>
            You are about to run {label} for {cronAccountingDate}. Proceed with execution?
          </h3>

          <div className="d-flex justify-content-between">
            <AButton
              className="no-ml-btn"
              onClick={closePopup}
              variant="primary_filled"
              updatedStyle={{backgroundColor : '#FFF', color : '#000', border : "1px solid #000"}}
            >
              Go Back
            </AButton>

            <AButton
              variant="danger_filled"
              className="no-ml-btn"
              onClick={() => runCron(closePopup)}
            >
              Yes, Execute
            </AButton>

          </div>

          {
            createdBy &&
            <small className={styles.lastUpdatedDate + " mt-1"}>Last executed by {createdBy} on {moment(startTime).format('DD/MM/YYYY')} at {getFormattedTime(startTime)}</small>
          }

        </div>
      )}
    />
    </div>
  )

}

const StockEnableDisable = () => {
  const [isEdit, setIsEdit] = useState(false);
  const [form, setForm] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const INITIAL_STATUS = MODULE_MASTER_TYPE.reduce((acc, curr) => {
    acc[curr.value] = null;;
    return acc;
  }, {});
  const [latestStatus, setLatestStatus] = useState(INITIAL_STATUS);

  const [paginationInfo, setPaginationInfo] = useState({
    currentPage: 0,
    totalPage: 0,
    totalRecords: 0,
  });
  const [currPageSize, setCurrentPageSize] = useState(50);

  const [cronStatusDetails, setCronStatusDetails] = useState([]);


  const userPermissions =
    RolePermissions(
      useContext(PermissionContext),
      pages["stockEnableDisable"]["id"]
    ) || [];

  const accountingCronPermissions = useGetPermissions('triggerAccountingCron');  

  useEffect(() => {
    // fetchLogs();
    init();
  }, []);

  const init = async() => {
    try{
      setIsLoading(true);
      await Promise.all[
        fetchLogs(),
        fetchCronStatus()
      ]
    }catch(err){
      console.error(err);
    }finally{
      setIsLoading(false);
    }
  }

  const fetchCronStatus = async() => {
    const status = await fetchAllPromisedData(endpoint.accountingCron.cronStatus);
    setCronStatusDetails(status);
  }

  const fetchLogs = async (pageNumber = 0, pageSize = currPageSize) => {
      const res = await fetchAllPromisedData(
        `${endpoint?.stockEnable?.getLogs}?offset=${pageNumber}&pageSize=${pageSize}&configType=ACCOUNT_MANAGEMENT`,
        true
      );
      if (res?.code === 200) {
        setRows(res.data.stockIssuanceConfigurationAudList);
        setCurrentPageSize(pageSize);
        setPaginationInfo({
          currentPage: res?.data?.currentPage,
          totalPage: res?.data?.totalPage,
          totalRecords: res?.data?.totalRecords,
        });
        // setRowCount(res.data.totalRecords);
        const latestStatus = res.data.stockIssuanceConfigurationList;
        console.log(latestStatus, "latestStatus");
        const currentLatestStatus = MODULE_MASTER_TYPE.reduce((acc, curr) => {
          acc[curr.value] = findModule(curr.value, latestStatus);
          return acc;
        }, {});
        console.log(currentLatestStatus, "currentLatestStatus");
        setLatestStatus(currentLatestStatus);
      } else {
        setRows([]);
      }

  };

  const nextButtonHandler = (newPage, currPageSize) => {
    fetchLogs(newPage, currPageSize);
  };



  const COLUMNS = [
    new AGridColDef("disabledModules", "Master Type", false)
      .setMinWidth(250)
      .editable(false)
      .renderCellComponent((params) => <div>{MODULE_MASTER_LABEL_VALUE_MAP[params?.value] || "-"}</div>),

    new AGridColDef("fromDate", "Positing Up to", false)
      .editable(false)
      .renderCellComponent((params) => (
        <div>
          {isEnableDayForm(params?.row.disabledModules)
            ? params?.row.daysBeforeStart
            : moment(params?.value).format("DD MMM YYYY")}{" "}
        </div>
      )),

    new AGridColDef("prevStatus", "Previous State", false)

      .editable(false)
      .renderCellComponent((params) => (
        <div style={{ textTransform: "capitalize" }}>
          {params?.value?.toLowerCase() || "-"}
        </div>
      )),

    new AGridColDef("status", "Current State", false).renderCellComponent(
      (params) => (
        <div style={{ textTransform: "capitalize" }}>
          {params?.value.toLowerCase() || "-"}
        </div>
      )
    ),

    new AGridColDef("updatedOn", "Updated On", false)

      .setMinWidth(200)
      .editable(true)
      .renderCellComponent((params) => (
        <div>{moment(params?.value).format("DD MMM YYYY")} at {getFormattedTime(params?.value)}</div>
      )),

    new AGridColDef("updatedBy", "Updated By", false).renderCellComponent(
      (params) => <div>{params?.value || "-"}</div>
    ),
  ];

  const handleBackClick = () => {
    window.history.go(-1);
  };

  const filterFormHandler = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value ?? [] }));
  };

  const handleEditStatus = (formValues = {}) => {
    const {
      disabledModules,
      status,
      fromDate,
      toDate,
      restrictedBU,
      daysBeforeStart,
      daysBeforeEnd,
    } = formValues;
    setIsEdit(true);
    setForm({
      moduleName: {
        value: disabledModules,
        label: MODULE_MASTER_TYPE.find((item) => item.value === disabledModules).label,
      },
      status: {
        value: status,
        label: statusDropdown.find((item) => item.value === status).label,
      },
      fromDate: moment(fromDate) || moment(),
      toDate: moment(toDate).endOf("day") || moment().endOf("day"),
      restrictedBU,
      daysBeforeStart,
      daysBeforeEnd,
    });
  };

  const handleUpdateStatus = async () => {
    try {
      setIsLoading(true);
      const payload = {
        moduleName: form.moduleName.value,
        status: form.status.value,
        fromDate: moment(form.fromDate).format("YYYY-MM-DD"),
        toDate: moment(form.toDate).format("YYYY-MM-DD"),
        restrictedBu: "ALL",
        daysBeforeStart: form?.daysBeforeStart,
        daysBeforeEnd: form?.daysBeforeEnd,
      };

      if (!payload?.daysBeforeEnd || !payload?.daysBeforeStart) {
        failureToast("Please enter valid days before start and end date");
        return;
      }

      const response = await fetchAllPostPromisedData(
        `${endpoint.stockEnable.updateStatus}`,
        payload,
        "post"
      );

      if (response?.code === 200) {
        setIsEdit(false);
        setForm({});
        fetchLogs();
        // if (currentPageNumber) setPageNumber(0);
        // else fetchLogs();
      }

    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };

  const isEnableDayForm = (moduleName) => {
    return true;
    return ["ISSUANCE_CONTROL", "RETURN_CONTROL"].includes(moduleName);
  };

  return (
    <div className="px-4">
      <div className="d-flex align-items-center text-dark">
        <IconButtonWrapper onClick={handleBackClick}>
          <BackIcon />
        </IconButtonWrapper>
        <h2 className="ml-2 mb-0">Accounting Posting Control</h2>
      </div>

      <div className={`${styles.card}`}>
        <h2 className={styles.heading}>Accounting Status</h2>

        <div className={styles.grid}>
          {MODULE_MASTER_TYPE.map(({ label, value }) => {
            const { updatedOn = "", status = "active" } =
              latestStatus[value] ?? {};

            return (
              <div key={value} className={`${styles.cardDetail} mt-2`}>
                <div className="d-flex flex-column w-100">
                  <div className="d-flex align-items-center justify-content-between">
                    <span
                      className={styles.statusBadge}
                      style={{
                        color:
                          status.toLowerCase() === "inactive"
                            ? "#B32306"
                            : "#0B442D",

                        background:
                          status.toLowerCase() === "inactive"
                            ? "#F9D9D7"
                            : "#BBE2CE",
                      }}
                    >
                      {status?.toLowerCase()}
                    </span>
                    <span
                      style={{ visibility: isEdit ? "hidden" : "visible" }}
                      className={styles.editIcon}
                    >
                      {(userPermissions?.includes("C") ||
                        userPermissions?.includes("U")) && (
                          <IconButtonWrapper
                            onClick={() => handleEditStatus(latestStatus[value])}
                            className={styles.editBtn}
                          >
                            <EditIcon width="12px" height="12px" />
                          </IconButtonWrapper>
                        )}
                    </span>
                  </div>
                  <h3 className={styles.cardHeading}>{label}</h3>
                  <small
                    style={{
                      visibility: !updatedOn ? "hidden" : "visible",
                    }}
                    className={styles.lastUpdatedDate}
                  >
                    Last updated on {moment(updatedOn).format("DD MMM YYYY")} at {getFormattedTime(updatedOn)}
                  </small>

                  {
                    accountingCronPermissions &&
                    <RunCRON
                      label={label}
                      value={value}
                      details={latestStatus[value]}
                      setIsLoading={setIsLoading}
                      cronStatusDetails={cronStatusDetails}
                      fetchCronStatus={fetchCronStatus}
                    />
                  }
                </div>
              </div>

            );
          })}
        </div>

        <div style={{ display: isEdit ? "block" : "none" }}>
          <h2 className={`${styles.tableHeading} mt-5`}>
            Change Status for {form?.moduleName?.label?.toLowerCase()}
          </h2>

          <div className={styles.form}>
            <AAutoComplete
              label="Master Type"
              placeholder="Select"
              items={MODULE_MASTER_TYPE}
              currentValue={form.moduleName}
              handleChange={(value) => {
                filterFormHandler("moduleName", value);
              }}
              isMulti={false}
              height="40px"
            />

            {isEnableDayForm(form.moduleName?.value) ? (
              <div className={styles["form_input"]}>
                <AInput
                  value={form.daysBeforeStart}
                  label="No of days current days*"
                  placeholder="Enter the value"
                  handler={(value) =>
                    filterFormHandler("daysBeforeStart", value)
                  }
                  maxLength={3}
                  regex={regex?.numeric}


                  style={AInputStyle}
                />
              </div>
            ) : (
              <div className="mt-auto">
                <small className="text-xs">Start Date</small>
                <CustomDatePicker
                  placeHolder="Start Date"
                  value={form.fromDate}
                  handler={(index, date, keyName) => {
                    filterFormHandler("fromDate", date);

                    //   update end-date
                    filterFormHandler("toDate", moment(date)?.add(1, "month"));
                  }}
                  minDate={moment.min([
                    moment(form.fromDate),
                    moment().subtract(1, "month"),
                  ])}
                  maxDate={moment()}
                />
              </div>
            )}
            {/* {isEnableDayForm(form.moduleName?.value) ? (
              <div className={styles["form_input"]}>
                <AInput
                  label="No. of days after course end date*"
                  value={form.daysBeforeEnd}
                  placeholder="Enter the value"
                  handler={(value) => filterFormHandler("daysBeforeEnd", value)}
                  maxLength={3}
                  regex={regex?.numeric}
                  style={AInputStyle}
                />
              </div>
            ) : ( */}
              {/* <div className="mt-auto">
                <small className="text-xs">End Date</small>
                <CustomDatePicker
                  placeHolder="End Date"
                  value={form.toDate}
                  handler={(index, date, keyName) => {
                    filterFormHandler("toDate", moment(date).endOf("day"));
                  }}
                  minDate={moment(form.fromDate)}
                  maxDate={moment(form.fromDate)?.add(1, "month")}
                />
              </div> */}
            {/* )} */}

            <AAutoComplete
              label="New Status"
              placeholder="Select"
              items={statusDropdown}
              currentValue={form.status}
              handleChange={(value) => {
                filterFormHandler("status", value);
              }}
              isMulti={false}
              height="40px"
            />

            <AButton
              variant="outline_danger"
              className="h-full no-ml-btn mt-auto"
              onClick={() => {
                setIsEdit(false);
                setForm({});
              }}
            >
              Cancel
            </AButton>

            <AButton
              variant="primary_filled"
              className="w-full no-ml-btn mt-auto"
              onClick={handleUpdateStatus}
            //   disabled={isDisabled}
            >
              Change status
            </AButton>
          </div>
        </div>
      </div>

      <div className={`${styles.card}`}>
        <h3 className={styles.tableHeading}>Change Logs</h3>
        <ADataGrid
          removeWrapperContainer
          rows={rows || []}
          columns={COLUMNS}
          rowId={(row) => row.rev}
          rowHeight={50}
          loading={false}
          rowCount={paginationInfo.totalRecords}
          nextButtonHandler={nextButtonHandler}
          currentPage={paginationInfo?.currentPage}
          sx={{
            ".MuiDataGrid-main": {
              height: "500px",
            },
          }}
          paginationModel={{ page: paginationInfo?.currentPage, pageSize: currPageSize }}
        />
      </div>

      {isLoading && (
        <Backdrop
          sx={() => ({
            color: "#fff",
          })}
          open={isLoading}
        >
          <ALoader />
        </Backdrop>
      )}
    </div>
  );
};

export default StockEnableDisable;
